export enum LocaleStorageKeys {
  IDENTITY_TOKEN = "__darwined_identity_token",
  CHS_2858_ONBOARDING_DISMISSALS = "__darwined_onboarding_chs_2858",
}
